
    import "src/app/AppSeller/SettingsPage/StoreAddress/components/AddressCard/index.module.scss?farm_css_modules";
    
    export default {"address": `address-38bfc8d5`,"addressCard": `addressCard-38bfc8d5`,"addressCardInnerContainer": `addressCardInnerContainer-38bfc8d5`,"addressId": `addressId-38bfc8d5`,"addressType": `addressType-38bfc8d5`,"editButton": `editButton-38bfc8d5`,"invoicePrefix": `invoicePrefix-38bfc8d5`,"left": `left-38bfc8d5`}
    